export const config = {
  GOOGLE_MAPS_API_KEY:
    process.env.GOOGLE_MAPS_API_KEY ||
    'AIzaSyByXUEp5uJuWPo7gK43dU4whsVIQwc1Npk',
};
